const reportMixin = {
    data() {
        return {
            formats: {
                pdf: '.pdf',
                excel: '.xlsx',
                word: '.docx'
            },
        }
    },
    methods: {
        createDownloadLink(response, report, format) {
            let url = '';

            if (this.isBinary(format))
                url = window.URL.createObjectURL(new Blob([response.data]));
            else
                url = response.data.data.file;

            const link = document.createElement('a');

            link.href = url;

            link.setAttribute('download', this.getTranslation(report) + '-' + this.$moment().format('DD.MM.YYYY HH-mm') + format);

            document.body.appendChild(link);

            link.click();
        },
        isBinary(format) {
            return format !== this.formats.pdf;
        },
        getAxiosConfig(filterForm) {
            let config = {
                responseType: 'json'
            };

            let params = this.cleanObject(filterForm);

            if (params.hasOwnProperty('withTrial')) {
                if (params.withTrial === true)
                    params.withTrial = 1;
                else
                    params.withTrial = 0;
            }

            if (params.hasOwnProperty('download')) {
                if (params.download === true)
                    params.download = 1;
                else
                    params.download = 0;
            }

            config.params = params;

            if (params.hasOwnProperty('format') && this.isBinary(params.format))
                config.responseType = 'blob';

            return config;
        },
    }
};
export default reportMixin;
